// eslint-disable-next-line @typescript-eslint/no-explicit-any
const envSettings = window as any;

export class Config {
  static readonly keycloakUrl = envSettings.REACT_APP_KEYCLOAK_BASE_URL;
  static readonly keycloakRealm = envSettings.REACT_APP_KEYCLOAK_REALM;
  static readonly apiUrl = envSettings.REACT_APP_CLIENT_API_BASE_URL;
  static readonly applicationScope = envSettings.REACT_APP_APPLICATION_SCOPE;
  static readonly env = envSettings.REACT_APP_ENV;
}
